export function getLocaleFromStore() {
    return localStorage.getItem("locale");
}

export function setLocaleToStore(value: string) {
    return localStorage.setItem("locale", value);
}